import React from 'react';

const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

const APPTCalendarHeader = () => (
	<div className='mb-2.5 grid grid-cols-7 gap-x-0.5'>
		{days.map((day, index) => (
			<div
				className='text-caption text-center text-black'
				key={`day${index}`}
			>
				<p>{day}</p>
			</div>
		))}
		<hr className='col-span-7' />
	</div>
);

export default APPTCalendarHeader;
